import React, { Component } from 'react';
import './UnitDetailsPage.css';
import Page from '../../components/page/Page';
import Card from '../../components/card/Card';
import DrugCard from '../../cards/drugCard/DrugCard';
import models from '../../model/models';
import Label from '../../components/label/Label';
import utils from '../../utils/utils';
import Button from '../../components/button/Button';
import mainAPI from '../../api/MainAPI';
import history from '../../history';
import toasts from '../../utils/toasts';
import CardHeader from '../../components/cardHeader/CardHeader';
import HeaderRow from '../../components/headerRow/HeaderRow';
import Row from '../../components/row/Row';
import NotificationCard from "../../cards/notificationCard/NotificationCard";
import DrugTypeSummary from "../../cards/drugTypeSummary/DrugTypeSummary";
import UpdateUnitPopup from "../../popups/updateUnitPopup/UpdateUnitPopup";

export default class UnitDetailsPage extends Component {
	constructor(props) {
		super(props);
		this.state = { drugs: [], unit: [], update: false, showArchive: false };
	}

	componentDidMount = () => {
		this._getData();
		this.subId = models.unit.onChange(this._getData);
		this.drugSububId = models.drug.onChange(this._getData);
		this.drugTypeSubId = models.drug_type.onChange(this._updateDrugTypes);
		this._getKnoxEvents().catch(console.error)

	};

	componentWillUnmount = () => {
		models.drug.unsubscribe(this.drugSububId);
		models.drug_type.unsubscribe(this.drugTypeSubId);
		models.unit.unsubscribe(this.subId);
	};

	_getKnoxEvents = async () => {
		let knox_events = await mainAPI.knox_event.for_unit(this.props.match.params.id);
		this.setState({ knox_events });
	};

	_updateDrugTypes = () => {
		let types = models.drug_type.allowed();
		this.setState({ types });
	};

	_getData = async () => {
		let unit = models.unit.obj(this.props.match.params.id);
		if (!unit) return;
		let drugs = await mainAPI.drug.forUnit(null, null, this.props.match.params.id);
		this.setState({ drugs, unit });
		const promise1 = this._getTransferData();
		const promise2 = this._getDrugBoxes();
		await Promise.all([promise1, promise2]);
	};

	_getTransferData = async () => {
		const id = this.props.match.params.id;
		let transfers = await mainAPI.box_transfer.for_unit(id);
		this.setState({ transfers });
	};

	_getDrugBoxes = async () => {
		const id = this.props.match.params.id;
		let drugBoxes = await mainAPI.drug_box.for_unit(id);
		this.setState({ drugBoxes });
	};

	_showUpdateUnitPopup = () => {
		this.setState({ update: true });
	};
	_hidePopup = () => {
		this.setState({ update: false });
		setTimeout(models.unit.refreshData, 1000);
	};
	_renderUpdatePopup = () => {
		if (!this.state.update) return null;
		return <UpdateUnitPopup {...this.state.unit} onClose={this._hidePopup} />;
	};
  updateSetting = async (key, value, successMessage) => {
    let unit = this.state.unit || {};
    let res = await mainAPI.unit.update({ id: unit.id, [key]: value });

    if (res) {
      unit = this.state.unit || {};
      unit[key] = res[key];
      this.setState({ unit });
      toasts.show(successMessage || 'Setting Updated');
    } else {
      toasts.show('Setting did not update');
    }
  };

  renderNotificationSettings = () => {
    const unit = this.state.unit || {};
    if(!this.props.match.params.id) return <></>
    if(unit.type !== 'deployed') return <Label>Notifications disabled for supply units</Label> //this is disabled on the backend as well
    return <NotificationCard unitId={this.props.match.params.id}/>
  }
	renderTransferList = () => {
		let transfers = this.state.transfers;
		if (!transfers) return null;
		let columns = [
			{ label: 'Transferred by' },
			{ label: 'Transferred on' },
			{ label: 'From unit' },
			{ label: 'To unit' },
			{ label: 'Box (code)' },
			{ label: 'Direction' }
		];
		let display = [<HeaderRow columns={columns} />];
		for (let i in transfers) {
			let direction = 'Out';
			if (transfers[i].to_unit_id == this.props.match.params.id) {
				direction = 'In';
			}
			display.push(
				<Row key={i}>
					<Label> {transfers[i].user_name}</Label>
					<Label> {utils.display_actual_datetime(transfers[i].created_on)}</Label>
					<Label> {transfers[i].from_unit_name}</Label>
					<Label> {transfers[i].to_unit_name}</Label>
					<Label> {transfers[i].box_name + ' (' + utils.upperCase(transfers[i].barcode_id) + ')'}</Label>
					<Label green={direction == 'In'} red={direction == 'Out'}>
						{' '}
						{direction}
					</Label>
				</Row>
			);
		}
		return display;
	};

	renderBoxes = () => {
		let drugBoxes = this.state.drugBoxes;
		if (!drugBoxes) return null;
		let columns = [{ label: 'Box' }, { label: 'Last checked on' }, { label: 'Last checked by' }, { label: 'code' }];
		let display = [<HeaderRow columns={columns} />];
		for (let i in drugBoxes) {
			display.push(
				<Row key={i}>
					<Label onClick={e=>history.navigate('/drug_box/' + drugBoxes[i].id)}> {drugBoxes[i].name}</Label>
					<Label> {utils.display_actual_datetime(utils.server_to_client_datetime(drugBoxes[i].last_checked_on))}</Label>
					<Label> {drugBoxes[i].last_checked_by}</Label>
					<Label> {utils.upperCase(drugBoxes[i].barcode_id)}</Label>
				</Row>
			);
		}
		return display;
	};
	renderKnoxEvents = () => {
		let knox_events = this.state.knox_events;
		if (!knox_events) return null;
		let columns = [
			{ label: 'Event' },
			{ label: 'Date' },
			{ label: 'Date Reported' },
			{ label: 'User' }
		];
		const display = [<HeaderRow columns={columns} />];
		const rows = []
		for (const i in knox_events) {
			rows.push(
				<Row key={i}>
					<Label> {knox_events[i].event_type}</Label>
					<Label> {utils.display_actual_datetime(knox_events[i].created_on)}</Label>
					<Label> {utils.display_actual_datetime(knox_events[i].reported_on)}</Label>
					<Label> {knox_events[i].user_name}</Label>
				</Row>
			);
		}
		display.push(<div className={'list-knox'}>{rows}</div> )
		return display;
	};

	render() {
		const { unit = {}, knox_events = {} } = this.state;

		let lastCheckedOn = utils.display_date(utils.server_to_client_datetime(unit.last_checked_on));
		if (!unit.last_checked_on) {
			lastCheckedOn = '';
		}
		const userGroup = models.user_group.obj() || {}
		return (
			<Page className="g-unit-details-page">
				{this._renderUpdatePopup()}
				<div className="top-cards">
					<Card half inline>
						<div className="g-unit-details-page-content">
							<div className="g-unit-details-page-content-data">
								<Label larger black>
									{unit.name}
								</Label>
								<Label black bold>Location</Label>
								<Label black>{unit.location}</Label>

								<Label black bold>Type</Label>
								<Label black capitalize>
									{unit.type}
								</Label>
							</div>
							<div className="g-unit-details-page-actions">

								<Button
									className="g-unit-details-page-actions-update"
									color="white"
									bg="blue"
									onClick={this._showUpdateUnitPopup}
								>
									Edit
								</Button>
								{Boolean(userGroup.enable_knox_integration) && <div>
									<Label black bold>Knox MedVault Serial Number</Label>
									<Label black>{unit.knox_box_serial_number}</Label>
								</div>}
							</div>
						</div>
					</Card>
					<Card half inline>
						<Label larger black>
							Recent Check
						</Label>
						<Label black bold>Last checked on</Label>
						<Label black>{lastCheckedOn}</Label>
						<Label black bold>Last checked by</Label>
						<Label black>{unit.last_checked_by}</Label>
						<Label black bold>Verified by</Label>
						<Label black>{unit.witness}</Label>
					</Card>
				</div>
				<DrugTypeSummary types={this.state.types}  unitId={this.props.match.params.id} hideEmpty/>
        <Card className='notifications'>
          <CardHeader>Unit Notification Settings</CardHeader>
          {this.renderNotificationSettings()}
        </Card>
				{Boolean(knox_events.length) && <Card className="knox-events">
					<CardHeader>Knox MedVault Events</CardHeader>
					{this.renderKnoxEvents()}
				</Card>
				}
				<Card className="boxes">
					<CardHeader>Boxes</CardHeader>
					{this.renderBoxes()}
				</Card>
				<DrugCard drugs={this.state.drugs}>
					{' '}
					<Button
						color="white"
						bg="blue"
						onClick={() => {
							history.navigate('/reports/unit/' + unit.id);
						}}
					>
						Run Report
					</Button>
				</DrugCard>

				<Card className="transfers">
					<CardHeader>Box Transfers</CardHeader>
					{this.renderTransferList()}
				</Card>

			</Page>
		);
	}
}



// WEBPACK FOOTER //
// ./src/pages/unitDetailsPage/UnitDetailsPage.jsx